import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { HAKLAI_ADD_MODES } from "../haklaiConstants";

const HaklaiAddPillButton = React.memo(function HaklaiAddPillButton({
  classes,
  mode = HAKLAI_ADD_MODES.ADD,
  disabled = false,
  onClick,
  label = "",
  readyLabel = "",
  unavailableLabel = ""
}) {
  const isUnavailable = disabled || mode === HAKLAI_ADD_MODES.UNAVAILABLE;
  const isReady = !isUnavailable;
  const helperText = label || (isReady ? readyLabel : unavailableLabel || readyLabel);

  return (
    <Tooltip title={helperText}>
      <span>
        <IconButton
          size="small"
          aria-label={helperText}
          disabled={isUnavailable}
          className={[
            "haklai-add-pill",
            classes.addPillButton,
            isUnavailable ? classes.addPillButtonDisabled : "",
            isReady ? classes.addPillButtonReady : ""
          ].filter(Boolean).join(" ")}
          onMouseDown={(event) => {
            event.preventDefault();
          }}
          onClick={isUnavailable ? undefined : onClick}
        >
          <AddIcon
            fontSize="small"
            className={isReady ? classes.addIconReady : classes.addIconDisabled}
          />
        </IconButton>
      </span>
    </Tooltip>
  );
});

export default HaklaiAddPillButton;
